<script setup lang="ts">
const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['update:value'])
const { t } = useI18n()
const route = useRoute()
const userStore = useUserStore()
const { info } = storeToRefs(userStore)

const showModal = ref(false)
const loading = ref(false)
const email = ref()
const emailRules = [
  (v: string) => !!v || t('Rules.EmailRequired'),
  (v: string) => /.+@.+\..+/.test(v) || t('Rules.EnterValidEmail'),
]
useLockAppScrollWhenVisible(showModal)

watch(
  () => props.value,
  val => {
    showModal.value = val
  },
)

watch(
  () => showModal.value,
  val => {
    emits('update:value', val)
  },
)

const isChangePassword = computed(() => route.name === 'ChangePassword')

const show = () => {
  showModal.value = true
}

const close = () => {
  showModal.value = false
  email.value = ''
}

// 重置密码:发送邮件
const resetPasswordBySendEmail = async () => {
  try {
    loading.value = true
    const params = {
      email: email.value,
    }
    await baseService.resetPasswordBySendEmail(params)
    GlobalThis.$globalAlert.open(t('Copywriting.CheckYourEmail'))
    close()
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
}

const save = () => {
  resetPasswordBySendEmail()
}

onMounted(() => {
  if (isChangePassword.value) {
    email.value = info.value?.email || ''
  }
})

defineExpose({
  show,
})
</script>

<template>
  <n-modal
    v-model:show="showModal"
    :mask-closable="false"
    :auto-focus="false"
    :trap-focus="false"
    transform-origin="center"
  >
    <div
      class="modal-content relative sm:w-125 sm:min-h-72.5 sm:py-6 w-11/12 min-h-72.5 rounded-3 py-4 box-border"
    >
      <div
        i-material-symbols:close-rounded
        class="absolute sm:top-6.25 sm:right-4 top-4 right-4 w-6 h-6 cursor-pointer"
        @click="close"
      />
      <div class="sm:px-6 px-4">
        <div
          class="sm:text-5.5 sm:leading-6.5 sm:text-left text-4.5 leading-6 text-center typeface-robotoMedium"
        >
          {{ t('Global.RestoreAccess') }}
        </div>
        <div class="mt-5">
          <div v-if="isChangePassword" class="mb-5 text-4 leading-6">
            {{ t('Copywriting.RestoreAccess2') }}
          </div>
          <div v-else class="mb-5 text-4 leading-6">
            {{ t('Copywriting.RestoreAccess') }}
          </div>
          <var-style-provider :style-vars="successTheme()">
            <var-input
              v-model="email"
              class="w-full"
              variant="outlined"
              :maxlength="100"
              :placeholder="t('Placeholder.Email')"
              show-count
              :rules="emailRules"
              :validate-trigger="['onBlur']"
            />
          </var-style-provider>
        </div>
        <div class="sm:mt-8 mt-6 flex items-center justify-between w-full">
          <DfansButton
            :text="t('Btn.Cancel')"
            class="!sm:w-55 !sm:h-11 !sm:text-4 !w-37.5 !h-10 !text-3.75"
            type="cancel"
            @click="close"
          />
          <DfansButton
            :loading="loading"
            :text="t('Btn.Send')"
            class="!sm:w-55 !sm:h-11 !sm:text-4 !w-37.5 !h-10 !text-3.75"
            type="default"
            @click="save"
          />
        </div>
      </div>
    </div>
  </n-modal>
</template>

<style lang="less" scoped>
:deep(.var-form-details) {
  width: 100%;
  padding-right: 16px;
}
</style>
